import GraphQLTextResult from '../../graphQLTextResult'
import toSnakeCase from '../../../util/toSnakeCase'
import { gql } from '@polleverywhere/graphql-client'

const createDiscourseResult = gql`
  mutation createDiscourseResult($input: ResultInput!) {
    createDiscourseResult(input: $input) {
      id
      value
      approved
    }
  }
`

export default class Result extends GraphQLTextResult {
  getQuery (action) {
    switch (action) {
      case 'create':
        return {
          action: 'mutate',
          parse: (json) => toSnakeCase(json.createDiscourseResult),
          query: createDiscourseResult,
          variables: {
            input: {
              participantKey: this.poll().get('participant_key'),
              value: this.get('value'),
              source: this.source.toUpperCase()
            }
          }
        }
      default:
        throw new Error(`Unknown query for ${action}`)
    }
  }

  // Avoiding race condition, see note in `createResultCreatedSubscription` of index.js
  save (key, val, options = {}) {
    this._isBeingCreated = true

    return super.save().then((data) => delete this._isBeingCreated)
  }
}
